export default __webpack_public_path__ + "static/media/axis-f.e5e66551.webp";